import { Text, type TextProps } from "./Text"

import "./Text.less"

export function TextBodyText({ className, ...props }: TextProps) {
  return <Text className={`TextBodyText ${className || ""}`} {...props} />
}
